import {modals} from '../../modal/init-modals';

export class Validation {
  constructor() {
    this._modals = modals;
    this._type = '';

    this._elements = document.querySelectorAll('[data-validation]');

    this._onSubmitForm = this._onSubmitForm.bind(this);

    this._emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

    this._errors = new Set();
  }

  init() {
    if (!this._elements.length) {
      return;
    }

    this._elements.forEach((element) => {
      const form = element.querySelector('[data-validation-form]');

      form.addEventListener('submit', this._onSubmitForm);
    });
  }

  _documentClickHandler(evt) {
    const target = evt.target;

    if (!target.closest('[data-open-modal]')) {
      return;
    }

    const button = target.closest('[data-open-modal]');

    if (button.getAttribute('data-type')) {
      this._type = button.getAttribute('data-type');
    } else {
      this._type = '';
    }
  }

  _loadCaptchaScript() {
    if (!window.__captchaLoadPromise) {
      window.__captchaLoadPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://smartcaptcha.cloud.yandex.ru/captcha.js';
        script.async = true;

        script.onload = () => {
          resolve();
        };

        script.onerror = () => {
          reject(new Error('Не удалось загрузить скрипт капчи'));
        };

        document.head.appendChild(script);
      });
    }

    return window.__captchaLoadPromise;
  }

  async _getToken(widgetId) {
    const response = window.smartCaptcha.getResponse(widgetId);

    if (response) {
      window.smartCaptcha.reset(widgetId);
    }

    const token = await window.smartCaptcha.executePromise(widgetId);

    return token;
  }

  async _onSubmitForm(evt) {
    evt.preventDefault();

    const form = evt.target;
    const errors = form.querySelector('[data-validation-errors]');

    errors.innerHTML = '';

    this._validateForm(form);

    if (this._errors.size) {
      this._setErrors(errors);
      return;
    }

    try {
      await this._loadCaptchaScript();
    } catch (err) {
      console.error('Captcha load error:', err);
      errors.innerHTML = this._createError('Ошибка загрузки капчи. Попробуйте отправить форму еще раз.');
      return;
    }

    const widget = form.querySelector('[data-validation-widget]');
    let widgetId = widget.dataset.validationWidget;

    if (!widgetId) {
      widgetId = window.smartCaptcha.render(widget, {
        sitekey: 'ysc1_fcxfCv6pUCclSSD3oF9f1h0iKfA6hVNPnE9HtvPRdaec1a71',
        invisible: true,
      });
      widget.setAttribute('data-validation-widget', widgetId);
    }

    const action = form.dataset.action;
    const token = await this._getToken(widgetId);

    const formData = new FormData(form);
    formData.append('action', action);
    formData.append('token', token);

    if (this._type) {
      formData.append('type', this._type);
      this._type = '';
    }

    switch (action) {
      case 'feedback':
        this._sendFeedback(form, formData);
        break;
      case 'order':
        this._sendFeedback(form, formData);
        // this._sendOrder(form, formData);
        break;
      default:
        this._sendFeedback(form, formData);
    }
  }

  _sendFeedback(form, formData) {
    BX.ajax.runComponentAction('custom:main.feedback', 'sendFeedback', {
      mode: 'class',
      data: formData,
    })
      .then((response) => {
        this._showMessage(form, response);
      })
      .catch((response) => {
        this._showMessage(form, response);
      });
  }

  _sendOrder(form, formData) {
    const product = document.querySelector('[data-product-detail]');

    if (product) {
      formData.append('product_id', product.dataset.productDetail);
    }

    BX.ajax.runComponentAction('custom:main.feedback', 'sendOrder', {
      mode: 'class',
      data: formData,
    })
      .then((response) => {
        this._showMessage(form, response);
      })
      .catch((response) => {
        this._showMessage(form, response);
      });
  }

  async _showMessage(form, response) {
    const errors = form.querySelector('[data-validation-errors]');

    errors.innerHTML = '';

    if (response.status === 'success') {
      if (form.closest('[data-modal]')) {
        const modalName = form.closest('[data-modal]').dataset.modal;

        if (this._timeoutId) {
          clearTimeout(this._timeoutId);
        }

        this._modals.close(modalName);
      }

      this._modals.open('success');

      this._timeoutId = setTimeout(() => {
        if (document.querySelector('[data-modal="success"].is-active')) {
          this._modals.close('success');
        }
      }, 3000);

      form.reset();
    } else if (response.status === 'error') {
      let errorResult = '';

      if (response.errors.length) {
        Array.from(response.errors).forEach((error) => {
          errorResult += this._createError(error.message);
        });
      }

      errors.innerHTML = errorResult;
    }
  }

  _validateForm(form) {
    this._errors.clear();

    const fields = form.querySelectorAll('[data-validation-type]');

    fields.forEach((field) => {
      const type = field.dataset.validationType;

      switch (type) {
        case 'text':
          this._validateTextField(field);
          break;
        case 'phone':
          this._validatePhoneField(field);
          break;
        case 'email':
          this._validateEmailField(field);
          break;
        case 'checkbox':
          this._validateCheckboxField(field);
          break;
        case 'textarea':
          this._validateTextAreaField(field);
          break;
      }
    });
  }

  _validateTextField(field) {
    const input = field.querySelector('input');

    if (!input.value) {
      field.classList.add('is-error');
      this._errors.add('required');
    } else {
      field.classList.remove('is-error');
    }
  }

  _validatePhoneField(field) {
    const input = field.querySelector('input');

    if (!input.value) {
      field.classList.add('is-error');
      this._errors.add('required');
    } else if (input.value.length < 18) {
      field.classList.add('is-error');
      this._errors.add('phone');
    } else {
      field.classList.remove('is-error');
    }
  }

  _validateEmailField(field) {
    const input = field.querySelector('input');

    if (field.hasAttribute('data-required')) {
      if (!input.value) {
        field.classList.add('is-error');
        this._errors.add('required');
      } else if (input.value && !this._emailRegex.test(input.value)) {
        field.classList.add('is-error');
        this._errors.add('email');
      } else {
        field.classList.remove('is-error');
      }
    } else {
      if (input.value && !this._emailRegex.test(input.value)) {
        field.classList.add('is-error');
        this._errors.add('email');
      } else {
        field.classList.remove('is-error');
      }
    }
  }

  _validateCheckboxField(field) {
    const input = field.querySelector('input');

    if (!input.checked) {
      field.classList.add('is-error');
      this._errors.add('checkbox');
    } else {
      field.classList.remove('is-error');
    }
  }

  _validateTextAreaField(field) {
    const textarea = field.querySelector('textarea');

    if (!textarea.value) {
      field.classList.add('is-error');
      this._errors.add('required');
    } else {
      field.classList.remove('is-error');
    }
  }

  _setErrors(element) {
    let result = '';

    this._errors.forEach((error, errorAgain, set) => {
      switch (error) {
        case 'required':
          result += this._createError('Заполните все обязательные поля');
          break;
        case 'phone':
          result += this._createError('Введите пожалуйста корректный номер телефона');
          break;
        case 'email':
          result += this._createError('Введите пожалуйста корректный адрес электронной почты');
          break;
        case 'checkbox':
          result += this._createError('Требуется согласие на обработку персональных данных');
          break;

      }
    });

    element.innerHTML = result;
  }

  _createError(text) {
    return `
      <div class="errors__error">
        <svg width="20" height="20">
          <use xlink:href="#icon-error"></use>
        </svg>
        <span>${text}</span>
      </div>`;
  }
}
